// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--1sINq";
export var footerInner = "footer-module--footer-inner--MKv9C";
export var footerNavigation = "footer-module--footer-navigation--2GCzZ";
export var footerCopyright = "footer-module--footer-copyright--1smg9";